import { ContactBlock } from "../../../types";
import ContactOptionsTabs from "@/components/calltoaction/CtaContact"; // Import existing contact tabs component

interface ContactProps {
  block: ContactBlock;
}

export default function Contact({ block }: ContactProps) {
  return (
    <div className="bg-gray-50">
      {(block.title || block.text) && (
        <div className="container mx-auto px-4 py-12 text-center">
          {block.title && (
            <h2 className="text-3xl md:text-4xl font-semibold text-dark-100 font-serif mb-4">
              {block.title}
            </h2>
          )}
          {block.text && (
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {block.text}
            </p>
          )}
        </div>
      )}
      <ContactOptionsTabs className="py-20" />
    </div>
  );
}
